import React, {Component} from "react";
import "./MonthlyReport.scss"
import GroupNav from '../DownloadReport/GroupNav';
import DatePicker from 'react-datepicker';
import moment from "moment";
import {schemaTypes} from '../../../../constants/constants'
import ReportAPIs from "../../../../APIs/ReportAPIs";
import GroupTable from '../GroupReport/groupTable';
import ReusableGraph from '../ReusableGraph/ReusableGraph';
import InMultiSelect from '../InMultiSelect/InMultiSelect';
import { JSONToCSVConvertor } from '../../../../helpers/helperFunctions';

class MonthlyReport extends Component{
    constructor(props){
        super(props)
        this.props = props
        this.state = {
            utilization_type: "",
            reportName: "",
            dropdownOpen: false,
            startDate: moment().subtract(1, "month").startOf("day").toDate(),
            endDate: moment().subtract(1, "day").endOf("day").toDate(),
            selectAllGroups: false,
            groups: [],
            selectedGroup: {},
            vehicleIds: [],
            selectedVehicleId: null, // For battery swap report single vehicle selection
            tableData: [],
            columns: [],
            graphData: null,
            busy: false,
            errorPage: false,
            canDownload: false,
            vehicleUsageSummary: null,
        }
        this.group = []
        this.vehicleSelect = React.createRef();
        
        // Header name mapping: API key -> Display name
        this.headerMapping = {
            'regno': 'Reg No',
            'vinno': 'VIN No',
            'make': 'Make',
            'model': 'Model',
            'month': 'Month',
            'totaldistance': 'Total Distance(KM)',
            'totalsoconsumed': 'Total SoC Consumed(%)',
            'startodometer': 'Start Odometer(KM)',
            'endodometer': 'End Odometer(KM)',
            'groupname': 'Group Name',
            'subgroupname': 'Sub Group Name',
            'currentodo': 'Current ODO',
            'time': 'Time',
            'isoperational': 'Operational',
            'vin': 'VIN No',
            'vehicleno': 'Vehicle No',
            'swaptimestamp': 'Swap Time',
            'socbefore': 'SoC Before',
            'socafter': 'SoC After',
            'socchange': 'SoC Change',
            // Vehicle usage bucketing
            'kmbelow10': 'Km below 10',
            'kmbelow20': 'Km below 20',
            'kmbelow30': 'Km below 30',
            'kmabove30': 'Km above 30',
            // Add more mappings as needed
        };
    }

    componentDidMount(){
        this.handleClickOutside = (e) => {
            let container = document.querySelector('.mrc-report-type');
            if (container && !container.contains(e.target)) {
                this.setState({dropdownOpen: false});
            }
        };
        document.addEventListener('mousedown', this.handleClickOutside);
        
        // Fix gap between tabs and content
        window.$('.rw-container').css('top', '53px');

        // Initialize group tree (without collecting vehicles)
        let group = this.props.props.groupTree;
        if(!group.path){
            group.path = "/0/";
            group.ppath = "/0/";
        }
        this.group = group;
        // Initialize groups state without navigating (no vehicle collection on load)
        let rootGroupPath = "";
        let nav = [];
        nav.push(this.group);
        this.setState({groups: nav});
    }

    componentWillUnmount() {
        if (this.handleClickOutside) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
        
        // Remove the top style when component unmounts
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    toggleDropdown = () => {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    };

    handleOptionClick = (value, name) => {
        const isBatterySwap = value === "battery-swap";

        // Clear window-selected vehicles only for battery swap to ensure fresh list
        if (isBatterySwap) {
            window.selectedVehicles = [];
            window.selectedItems = [];
        }

        this.setState(
            {
                utilization_type: value,
                reportName: name,
                dropdownOpen: false,
                selectedVehicleId: null, // Reset vehicle selection when changing report type
                // Only reset group selections for battery-swap; otherwise keep existing selection/toggle
                selectAllGroups: isBatterySwap ? false : this.state.selectAllGroups,
                selectedGroup: isBatterySwap ? {} : this.state.selectedGroup,
                vehicleIds: isBatterySwap ? [] : this.state.vehicleIds,
                // Clear any previously shown data when switching report
                tableData: [],
                columns: [],
                graphData: null,
                canDownload: false,
                errorPage: false,
                vehicleUsageSummary: null,
            },
            () => {
                // Force InMultiSelect to refresh its data after state update for battery-swap
                if (isBatterySwap && this.vehicleSelect && this.vehicleSelect.current) {
                    if (this.vehicleSelect.current.setData && this.props.props.store) {
                        const vehicleData = (() => {
                            let newMap = {};
                            for (let idx in this.props.props.store.vehicleMap) {
                                if (idx.indexOf("user") === -1) {
                                    newMap[idx] = this.props.props.store.vehicleMap[idx];
                                }
                            }
                            return {
                                data: newMap,
                                name: "vehicleno",
                                id: "vehicleid",
                            };
                        })();
                        this.vehicleSelect.current.setData(vehicleData);
                    }
                }
            }
        );
    };

    changeVehicle = (selectedItems) => {
        window.saveVehicleState(selectedItems);
        // For single select, get the first item's ID
        const vehicleId = selectedItems && selectedItems.length > 0 
            ? (selectedItems[0].id || (selectedItems[0].data && selectedItems[0].data.vehicleid) || selectedItems[0].vehicleid)
            : null;
        this.setState({ selectedVehicleId: vehicleId });
    }

    getReportType = () => {
        const reportTypes = [
            { key: "utilization-report", name: "Utilization Report" },
            { key: "utilization-graph", name: "Utilization Graph" },
            { key: "operational-status", name: "Operational Status" },
            { key: "battery-swap", name: "Battery Swap Report" },
            { key: "vehicle-usage", name: "Vehicle Usage Report" },
        ];
        
        return reportTypes.map((report, index) => {
            return (
                <div
                    key={index}
                    className="dropdown-option"
                    onClick={() => this.handleOptionClick(report.key, report.name)}
                >
                    {report.name}
                </div>
            );
        });
    };

    handleStartDate = (date) => {
        // If operational-status is selected, show disabled message
        if (this.state.utilization_type === "operational-status") {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name: "Date Selection Disabled",
                    content: "Date selection is disabled for Operational Status report.",
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError: true
                },
            });
            return;
        }
        // Set start date to 00:00 (midnight) of the selected date
        const startDateWithTime = moment(date).startOf("day").toDate();
        this.setState({startDate: startDateWithTime})
    }

    handleEndDate = (date) => {
        // If operational-status is selected, show disabled message
        if (this.state.utilization_type === "operational-status") {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name: "Date Selection Disabled",
                    content: "Date selection is disabled for Operational Status report.",
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError: true
                },
            });
            return;
        }
        // Set end date to 23:59 (11:59 PM) of the selected date
        const endDateWithTime = moment(date).endOf("day").toDate();
        this.setState({endDate: endDateWithTime})
    }

    // Recursively collect vehicle IDs from a group and all its sub-groups
    collectVehicleIdsFromGroup = (group) => {
        let vehicleIds = [];
        
        if (!group) {
            return vehicleIds;
        }

        // Collect vehicles from current group
        if (group.vehicles && Array.isArray(group.vehicles)) {
            group.vehicles.forEach(vehicle => {
                const vehicleId = vehicle.id || vehicle.vehicleid || vehicle.userid;
                if (vehicleId) {
                    vehicleIds.push(vehicleId);
                }
            });
        }

        // Also collect from users array (some groups have users instead of vehicles)
        if (group.users && Array.isArray(group.users)) {
            group.users.forEach(user => {
                const vehicleId = user.id || user.userid || user.vehicleid;
                if (vehicleId) {
                    vehicleIds.push(vehicleId);
                }
            });
        }

        // Recursively collect vehicles from all sub-groups
        // Process all children groups, including those with groupid === 0 (like "Users" group)
        if (group.children && Array.isArray(group.children)) {
            group.children.forEach(childGroup => {
                // Process all valid child groups (including groupid === 0)
                if (childGroup && typeof childGroup === 'object') {
                    const childVehicleIds = this.collectVehicleIdsFromGroup(childGroup);
                    vehicleIds = [...vehicleIds, ...childVehicleIds];
                }
            });
        }

        // Remove duplicates (in case a vehicle appears in multiple groups)
        return [...new Set(vehicleIds)];
    }

    navigate = (group) => {
        let rootGroupPath = "";
        let path = group.path;
        let pathArray = path.split("/");
        pathArray.splice(0,1);
        pathArray = pathArray.splice(0, pathArray.length-1);
        let currentPath = rootGroupPath;
        let nav = [];
        let currentNode = this.group;
        nav.push(currentNode);
        for(let idx in pathArray){
            currentPath += "/" + pathArray[idx];
            for(let jdx in currentNode.children){
                if(currentNode.children[jdx].path === currentPath + "/"){
                    currentNode = currentNode.children[jdx];
                    if(!("children" in currentNode))
                        currentNode.children = [];
                    nav.push(currentNode);
                    break;
                }
            }
        }
        
        // Collect vehicle IDs from the selected group and all its sub-groups
        const vehicleIds = this.collectVehicleIdsFromGroup(group);
        
        this.setState({groups: nav, selectedGroup: group, vehicleIds: vehicleIds});
    }

    toggleSelectAllGroups = () => {
        const newSelectAllGroups = !this.state.selectAllGroups;
        
        if (newSelectAllGroups) {
            // Collect all vehicles from the main group tree and all sub-groups
            const vehicleIds = this.collectVehicleIdsFromGroup(this.group);
            this.setState({
                selectAllGroups: true, 
                vehicleIds: vehicleIds,
                selectedGroup: {} // Clear selected group when selecting all
            });
        } else {
            // Clear vehicle IDs and selected group when unchecking
            this.setState({
                selectAllGroups: false, 
                vehicleIds: [],
                selectedGroup: {}
            });
        }
    }

    // Validate if all required fields are filled
    isFormValid = () => {
        // Check if report type is selected
        const hasReportType = this.state.utilization_type !== "" && 
                             this.state.utilization_type !== null && 
                             this.state.utilization_type !== undefined;
        
        // For operational-status, only report type is required (vehicles can be selected later or from window.selectedItems)
        if (this.state.utilization_type === "operational-status") {
            return hasReportType;
        }
        
        // For battery-swap, require report type and a vehicle selection
        if (this.state.utilization_type === "battery-swap") {
            // Check if a vehicle is selected from the InMultiSelect component
            const hasVehicle = this.state.selectedVehicleId !== null && 
                              this.state.selectedVehicleId !== undefined;
            
            // Also check window.selectedItems and window.selectedVehicles as fallback
            const hasVehicleFromWindow = (window.selectedItems && window.selectedItems.length > 0) ||
                                        (window.selectedVehicles && window.selectedVehicles.length > 0);
            
            return hasReportType && (hasVehicle || hasVehicleFromWindow);
        }
        // For vehicle-usage, require report type, dates, and at least one vehicle (from group selection or window caches)
        if (this.state.utilization_type === "vehicle-usage") {
            const hasReportType = true; // already true here
            const hasStartDate = this.state.startDate !== null && this.state.startDate !== undefined;
            const hasEndDate = this.state.endDate !== null && this.state.endDate !== undefined;
            // vehicleIds populated from group selection; fallback to window selections
            const hasVehicles = (this.state.vehicleIds && this.state.vehicleIds.length > 0) ||
                (window.selectedItems && window.selectedItems.length > 0) ||
                (window.selectedVehicles && window.selectedVehicles.length > 0);
            return hasReportType && hasStartDate && hasEndDate && hasVehicles;
        }
        
        // For other date-based reports, require vehicles/groups and dates
        // Check if group/vehicles are selected
        // Either "Select All Groups" is checked OR a specific group is selected (with valid groupid)
        const hasGroupOrVehicles = this.state.selectAllGroups || 
            (this.state.selectedGroup && 
             this.state.selectedGroup.groupid !== undefined && 
             this.state.selectedGroup.groupid !== null &&
             Object.keys(this.state.selectedGroup).length > 0);
        
        // Check if start date is selected
        const hasStartDate = this.state.startDate !== null && this.state.startDate !== undefined;
        
        // Check if end date is selected
        const hasEndDate = this.state.endDate !== null && this.state.endDate !== undefined;
        
        return hasGroupOrVehicles && hasStartDate && hasEndDate && hasReportType;
    }

    // Process API response and generate columns dynamically
    processResponseData = (response) => {
        if (!response || !Array.isArray(response) || response.length === 0) {
            return { data: [], columns: [] };
        }

        // Get all unique keys from the response objects
        const allKeys = new Set();
        response.forEach(item => {
            Object.keys(item).forEach(key => allKeys.add(key));
        });

        // Generate columns from keys with header mapping
        const columns = Array.from(allKeys).map(key => {
            // Check if there's a mapping for this key
            const mappedName = this.headerMapping[key.toLowerCase()];
            
            // If mapping exists, use it; otherwise format the key
            const displayName = mappedName || 
                (key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '));
            
            return {
                key: key,
                name: displayName
            };
        });

        // Format data - ensure all items have all keys (fill missing with empty string)
        const data = response.map(item => {
            const formattedItem = {};
            columns.forEach(col => {
                let value = item[col.key];
                
                // Handle boolean values - convert to "Yes" or "No"
                if (typeof value === 'boolean') {
                    value = value ? 'Yes' : 'No';
                }
                // Handle null/undefined
                else if (value === undefined || value === null) {
                    value = '';
                }
                
                formattedItem[col.key] = value;
            });
            return formattedItem;
        });

        return { data, columns };
    }

    // Process graph data from API response
    processGraphData = (response) => {
        // Handle both direct array and object with data property
        let data = null;
        if (Array.isArray(response)) {
            data = response;
        } else if (response && response.data && Array.isArray(response.data)) {
            data = response.data;
        }
        
        if (!data || data.length === 0) {
            return null;
        }
        
        // Extract dates for x-axis
        const dates = data.map(item => item.date || moment(item.daystarttime).format('DD-MMM-YYYY'));
        
        // Extract data for each series
        const totalOdometer = data.map(item => item.totalodometer || 0);
        const totalDistance = data.map(item => item.totaldistance || 0);
        const totalSoConsumed = data.map(item => item.totalsoconsumed || 0);

        return {
            dates,
            totalOdometer,
            totalDistance,
            totalSoConsumed
        };
    }

    // Get graph configuration for ReusableGraph component
    getGraphConfig = () => {
        const { graphData } = this.state;
        
        if (!graphData) {
            return null;
        }

        return {
            type: 'mixed', // Mixed line and bar chart
            data: graphData.dates, // X-axis data
            xAxisData: graphData.dates,
            series: [
                {
                    name: 'Total Odometer',
                    type: 'line',
                    yAxisIndex: 0,
                    data: graphData.totalOdometer,
                    smooth: true,
                    itemStyle: {
                        color: '#5470c6'
                    }
                },
                {
                    name: 'Total Distance',
                    type: 'bar',
                    yAxisIndex: 1,
                    data: graphData.totalDistance,
                    itemStyle: {
                        color: '#91cc75'
                    }
                },
                {
                    name: 'Total SoC Consumed',
                    type: 'bar',
                    yAxisIndex: 1,
                    data: graphData.totalSoConsumed,
                    itemStyle: {
                        color: '#fac858'
                    }
                }
            ],
            options: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                grid: {
                    bottom: 150, // Add more bottom padding to accommodate rotated labels and legend
                    left: 60,
                    right: 60,
                    top: 60
                },
                legend: {
                    data: ['Total Odometer', 'Total Distance', 'Total SoC Consumed'],
                    bottom: 0 // Position legend at the very bottom
                },
                xAxis: {
                    rotate: 90, // Rotate labels 90 degrees (vertical)
                    interval: 0, // Show all labels (no skipping)
                    axisLabel: {
                        margin: 10 // Add margin between labels and axis
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Total Odometer',
                        position: 'left',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    {
                        type: 'value',
                        name: 'Distance / SoC',
                        position: 'right',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    }
                ]
            }
        };
    }

    downloadReport = () => {
        const { tableData, columns, utilization_type, graphData } = this.state;

        const toast = (name, content, showError = false) => {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name,
                    content,
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError
                },
            });
        };

        // No data guard
        if (utilization_type === "utilization-report") {
            if (!tableData || !tableData.length) {
                toast("No Data", "No table data available to download.", true);
                return;
            }

            // Build rows using column display names
            let rows = [];
            const cols = (columns && columns.length) ? columns : Object.keys(tableData[0] || {}).map(k => ({ key: k, name: k }));
            tableData.forEach(item => {
                let row = {};
                cols.forEach(col => {
                    row[col.name || col.key] = item[col.key];
                });
                rows.push(row);
            });

            const stamp = moment().format("YYYYMMDD_HHmmss");
            JSONToCSVConvertor(rows, `Utilization_Report_${stamp}`, false, true, false);
            toast("Download", `Utilization report downloaded (${stamp}).`);
        } else if (utilization_type === "utilization-graph") {
            if (!graphData) {
                toast("No Data", "No graph data available to download.", true);
                return;
            }

            // Flatten graph data to CSV rows
            const { dates, totalOdometer, totalDistance, totalSoConsumed } = graphData;
            const rows = dates.map((date, idx) => ({
                Date: date,
                "Total Odometer": totalOdometer[idx],
                "Total Distance": totalDistance[idx],
                "Total SoC Consumed": totalSoConsumed[idx],
            }));

            const stamp = moment().format("YYYYMMDD_HHmmss");
            JSONToCSVConvertor(rows, `Utilization_Graph_${stamp}`, false, true, false);
            toast("Download", `Utilization graph data downloaded (${stamp}).`);
        } else {
            // Table downloads for all other report types
            if (!tableData || !tableData.length) {
                toast("No Data", "No table data available to download.", true);
                return;
            }

            const typeToName = {
                "utilization-report": "Utilization_Report",
                "operational-status": "Operational_Status_Report",
                "battery-swap": "Battery_Swap_Report",
                "vehicle-usage": "Vehicle_Usage_Report",
            };

            let rows = [];
            const cols = (columns && columns.length) ? columns : Object.keys(tableData[0] || {}).map(k => ({ key: k, name: k }));
            tableData.forEach(item => {
                let row = {};
                cols.forEach(col => {
                    row[col.name || col.key] = item[col.key];
                });
                rows.push(row);
            });

            const stamp = moment().format("YYYYMMDD_HHmmss");
            const filename = typeToName[utilization_type] || "Report";
            JSONToCSVConvertor(rows, `${filename}_${stamp}`, false, true, false);
            toast("Download", `${filename.replace(/_/g, " ")} downloaded (${stamp}).`);
        }
    }

    getReport = () => {
        if (!this.isFormValid()) {
            return;
        }
        
        const { utilization_type, vehicleIds, startDate, endDate, selectedGroup } = this.state;
        
        // Set loading state
        this.setState({ busy: true, errorPage: false, tableData: [], columns: [], graphData: null, canDownload: false });
        
        // Handle battery-swap report (requires vehicle and dates)
        if (utilization_type === "battery-swap") {
            // Get vehicle ID from state or fallback to window.selectedItems
            let finalVehicleId = this.state.selectedVehicleId;
            
            if (!finalVehicleId) {
                // Fallback to window.selectedItems
                if (window.selectedItems && window.selectedItems.length > 0) {
                    finalVehicleId = window.selectedItems[0].id || 
                                   (window.selectedItems[0].data && window.selectedItems[0].data.vehicleid) || 
                                   window.selectedItems[0].vehicleid;
                }
                // Fallback to window.selectedVehicles
                else if (window.selectedVehicles && window.selectedVehicles.length > 0) {
                    finalVehicleId = window.selectedVehicles[0].id || 
                                   (window.selectedVehicles[0].data && window.selectedVehicles[0].data.vehicleid) || 
                                   window.selectedVehicles[0].vehicleid;
                }
            }
            
            if (!finalVehicleId) {
                this.props.props.dispatch({
                    type: "ADD_INTOAST",
                    data: {
                        name: "No Vehicle Selected",
                        content: "Please select a vehicle to get the battery swap report.",
                        createAt: Date.now(),
                        autoClose: 4000,
                        showError: true
                    },
                });
                this.setState({ busy: false });
                return;
            }
            
            // Convert dates to timestamps
            const starttime = moment(startDate).unix() * 1000;
            const endtime = moment(endDate).unix() * 1000;
            
            const body = {
                vehicleids: [finalVehicleId], // API expects array
                starttime: starttime,
                endtime: endtime
            };
            
            ReportAPIs.getBatterySwapReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Generated",
                            content: "Battery swap report generated successfully.",
                            createAt: Date.now(),
                            autoClose: 4000,
                            showError: false
                        },
                    });
                })
                .catch((error) => {
                    console.error("Battery Swap Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch battery swap report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
            return;
        }

        // Handle vehicle-usage report (requires vehicles/groups and dates)
        if (utilization_type === "vehicle-usage") {
            // Use vehicleIds collected from group selection
            let finalVehicleIds = vehicleIds;
            // Fallback to window selections if empty
            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                if (window.selectedItems && window.selectedItems.length > 0) {
                    finalVehicleIds = window.selectedItems.map(item => item.id || (item.data && item.data.vehicleid) || item.vehicleid).filter(Boolean);
                } else if (window.selectedVehicles && window.selectedVehicles.length > 0) {
                    finalVehicleIds = window.selectedVehicles.map(item => item.id || (item.data && item.data.vehicleid) || item.vehicleid).filter(Boolean);
                }
            }

            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                this.props.props.dispatch({
                    type: "ADD_INTOAST",
                    data: {
                        name: "No Vehicles Selected",
                        content: "Please select at least one vehicle or group to get the report.",
                        createAt: Date.now(),
                        autoClose: 4000,
                        showError: true
                    },
                });
                this.setState({ busy: false });
                return;
            }

            const starttime = moment(startDate).unix() * 1000;
            const endtime = moment(endDate).unix() * 1000;

            const body = {
                vehicleids: finalVehicleIds,
                starttime,
                endtime,
            };

            ReportAPIs.getVehicleUsageReport(body)
                .then((response) => {
                    const sourceData = (response && response.vehiclebucketing) ? response.vehiclebucketing : response;
                    const summaryData = response && typeof response === 'object' ? {
                        groupname: response.groupname,
                        noofvehicles: response.noofvehicles,
                        operationalvehicles: response.operationalvehicles,
                        nonoperationalvehicles: response.nonoperationalvehicles,
                        avgkm: response.avgkm,
                        maxkm: response.maxkm,
                        totalkm: response.totalkm,
                    } : null;
                    const { data, columns } = this.processResponseData(sourceData);
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0,
                        vehicleUsageSummary: summaryData,
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Generated",
                            content: "Vehicle usage report generated successfully.",
                            createAt: Date.now(),
                            autoClose: 4000,
                            showError: false
                        },
                    });
                })
                .catch((error) => {
                    console.error("Vehicle Usage Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch vehicle usage report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
            return;
        }
        
        // Handle operational-status report (no dates required)
        if (utilization_type === "operational-status") {
            // Get vehicle IDs from state or fallback to window.selectedItems
            let finalVehicleIds = vehicleIds;
            
            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                // Fallback to window.selectedItems
                if (window.selectedItems && window.selectedItems.length > 0) {
                    finalVehicleIds = window.selectedItems.map(item => {
                        return item.id || (item.data && item.data.vehicleid) || item.vehicleid;
                    }).filter(id => id !== undefined && id !== null);
                }
                // Fallback to window.selectedVehicles
                else if (window.selectedVehicles && window.selectedVehicles.length > 0) {
                    finalVehicleIds = window.selectedVehicles.map(item => {
                        return item.id || (item.data && item.data.vehicleid) || item.vehicleid;
                    }).filter(id => id !== undefined && id !== null);
                }
            }
            
            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                this.props.props.dispatch({
                    type: "ADD_INTOAST",
                    data: {
                        name: "No Vehicles Selected",
                        content: "Please select at least one vehicle or group to get the report.",
                        createAt: Date.now(),
                        autoClose: 4000,
                        showError: true
                    },
                });
                this.setState({ busy: false });
                return;
            }
            
            const body = {
                vehicleids: finalVehicleIds
            };
            
            // Add groupid if a group is selected
            if (this.state.selectedGroup && this.state.selectedGroup.groupid !== undefined && this.state.selectedGroup.groupid !== null) {
                body.groupid = this.state.selectedGroup.groupid;
            }
            
            ReportAPIs.getOperationalStatusReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Generated",
                            content: "Operational status report generated successfully.",
                            createAt: Date.now(),
                            autoClose: 4000,
                            showError: false
                        },
                    });
                })
                .catch((error) => {
                    console.error("Operational Status Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch operational status report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
            return;
        }
        
        // Convert dates to timestamps for other report types
        const starttime = moment(startDate).unix() * 1000;
        const endtime = moment(endDate).unix() * 1000;
        
        // Prepare request body
        const body = {
            vehicleids: vehicleIds,
            utilization_type: utilization_type,
            starttime: starttime,
            endtime: endtime
        };
        
        // Call appropriate API based on utilization_type
        if (utilization_type === "utilization-report") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                })
                .catch((error) => {
                    console.error("Utilization Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch utilization report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        } else if (utilization_type === "utilization-graph") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    // Process response data for graph display
                    const graphData = this.processGraphData(response);
                    
                    this.setState({
                        graphData: graphData,
                        tableData: [],
                        columns: [],
                        busy: false,
                        errorPage: !graphData,
                        canDownload: !!graphData
                    });
                })
                .catch((error) => {
                    console.error("Utilization Graph Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        graphData: null,
                        tableData: [],
                        columns: [],
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Graph Failed",
                            content: "Failed to fetch utilization graph. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        }
    }

    render(){
        return(
            <div className="monthlyReport">
                <div className="mrc-content">
                    <div className="mrcr-group">
                        <div className="mrcrg-selected">
                            <div className="mrc-select-all-toggle">
                                <label className="mrc-toggle-label">
                                    <input
                                        type="checkbox"
                                        checked={this.state.selectAllGroups}
                                        onChange={this.toggleSelectAllGroups}
                                        className="mrc-toggle-checkbox"
                                        disabled={this.state.utilization_type === "battery-swap"}
                                    />
                                    <span className="mrc-toggle-text">Select All Groups</span>
                                </label>
                            </div>
                            <div className={`mrcrgs-nav ${this.state.selectAllGroups || this.state.utilization_type === "battery-swap" ? 'disabled' : ''}`}>
                                <GroupNav
                                    props={this.state}
                                    navigate={this.navigate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mrc-controls-row">
                        <div className="mrcr-type" ref="reportContainer">
                            <div className="dropdown">
                                <div 
                                    className={this.state.dropdownOpen ? "dropdown-select-active" : "dropdown-select"} 
                                    onClick={this.toggleDropdown}
                                >
                                    {this.state.reportName ? this.state.reportName : "Select Report"}
                                </div>
                                {this.state.dropdownOpen && (
                                    <div className="dropdown-options">
                                        {this.getReportType()}
                                    </div>
                                )}
                            </div>
                        </div>
                        {this.state.utilization_type === "battery-swap" && (
                            <div className="mrc-vehicle-selection">
                                <InMultiSelect
                                    key={`battery-swap-vehicle-${this.state.utilization_type}`}
                                    ref={this.vehicleSelect}
                                    data={{
                                        storeData: (state) => {
                                            let newMap = {};
                                            for (let idx in state.vehicleMap) {
                                                if (idx.indexOf("user") === -1) {
                                                    newMap[idx] = state.vehicleMap[idx];
                                                }
                                            }
                                            return {
                                                data: newMap,
                                                name: "vehicleno",
                                                id: "vehicleid",
                                            };
                                        },
                                        key: 'vehicle',
                                        singleSelect: true,
                                        onItemChange: this.changeVehicle.bind(this),
                                        schemaKey: "utilization_report",
                                        defaultValue: () => {
                                            // Return empty array to ensure fresh start
                                            return {
                                                data: [],
                                                updatedAt: Date.now(),
                                            };
                                        }
                                    }}
                                />
                            </div>
                        )}
                        <div className={`mrc-date-selection ${this.state.utilization_type === "operational-status" ? 'disabled' : ''}`}>
                            <div 
                                className="mrcrd-picker"
                                onClick={(e) => {
                                    if (this.state.utilization_type === "operational-status") {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.props.dispatch({
                                            type: "ADD_INTOAST",
                                            data: {
                                                name: "Date Selection Disabled",
                                                content: "Date selection is disabled for Operational Status report.",
                                                createAt: Date.now(),
                                                autoClose: 4000,
                                                showError: true
                                            },
                                        });
                                    }
                                }}
                            >
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.startDate}
                                    onChange={(e) => this.handleStartDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="Start Date"
                                    disabled={this.state.utilization_type === "operational-status"}
                                    readOnly={this.state.utilization_type === "operational-status"}
                                />
                            </div>
                            <div 
                                className="mrcrd-picker"
                                onClick={(e) => {
                                    if (this.state.utilization_type === "operational-status") {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.props.dispatch({
                                            type: "ADD_INTOAST",
                                            data: {
                                                name: "Date Selection Disabled",
                                                content: "Date selection is disabled for Operational Status report.",
                                                createAt: Date.now(),
                                                autoClose: 4000,
                                                showError: true
                                            },
                                        });
                                    }
                                }}
                            >
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.endDate}
                                    onChange={(e) => this.handleEndDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="End Date"
                                    disabled={this.state.utilization_type === "operational-status"}
                                    readOnly={this.state.utilization_type === "operational-status"}
                                />
                            </div>
                        </div>
                        <div className="mrcr-download">
                            <button 
                                className={`mrcr-btn ${!this.isFormValid() ? 'disabled' : ''}`}
                                onClick={this.getReport}
                                disabled={!this.isFormValid()}
                            >
                                Get Report
                            </button>
                            <button 
                                className={`mrcr-btn-icon ${!this.state.canDownload ? 'disabled' : ''}`}
                                onClick={this.downloadReport}
                                title="Download"
                                disabled={!this.state.canDownload}
                            >
                                <i className="fa fa-download" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                {this.state.utilization_type === "vehicle-usage" && this.state.vehicleUsageSummary ? (
                    <div className="mrc-usage-summary">
                        {[
                            { label: "Group", value: this.state.vehicleUsageSummary.groupname },
                            { label: "Total Vehicles", value: this.state.vehicleUsageSummary.noofvehicles },
                            { label: "Operational", value: this.state.vehicleUsageSummary.operationalvehicles },
                            { label: "Non Operational", value: this.state.vehicleUsageSummary.nonoperationalvehicles },
                            { label: "Avg Km", value: this.state.vehicleUsageSummary.avgkm },
                            { label: "Max Km", value: this.state.vehicleUsageSummary.maxkm },
                            { label: "Total Km", value: this.state.vehicleUsageSummary.totalkm },
                        ].map((item, idx) => (
                            <div className="summary-item" key={`usage-summary-${idx}`}>
                                <div className="label">{item.label}</div>
                                <div className="value">{item.value ?? "-"}</div>
                            </div>
                        ))}
                    </div>
                ) : null}
                    <div className="mrc-table-section">
                        <div className="mrc-group-table">
                            {this.state.utilization_type === "utilization-graph" && this.state.graphData ? (
                                <ReusableGraph
                                    graphConfig={this.getGraphConfig()}
                                    height={600}
                                />
                            ) : null}
                            {(this.state.utilization_type === "utilization-report" || this.state.utilization_type === "operational-status" || this.state.utilization_type === "battery-swap" || this.state.utilization_type === "vehicle-usage") && this.state.tableData && this.state.tableData.length > 0 && this.state.columns.length > 0 ? (
                                <GroupTable
                                    data={this.state.tableData}
                                    columns={this.state.columns}
                                />
                            ) : null}
                            {this.state.busy ? (
                                <div className="mrc-table-loader">
                                    <div className="loading">Loading...</div>
                                </div>
                            ) : null}
                            {this.state.errorPage && !this.state.busy ? (
                                <div className="mrc-error-page">
                                    <div>NO DATA</div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default MonthlyReport;
